import { useState } from "react";
import { Link } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await apiClient.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setSent(true); // never reveal whether the account exists
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0F0D] text-white flex flex-col px-5 py-8">
      <Link to="/login" className="flex items-center gap-2 text-sm text-white/50 hover:text-white mb-8"><ArrowLeft className="h-4 w-4" /> Connexion</Link>
      <div className="max-w-sm w-full mx-auto">
        <Logo size="lg" />
        <h1 className="font-display text-3xl font-black mt-8 mb-2">Mot de passe oublié</h1>
        {sent ? (
          <div data-testid="forgot-sent-message" className="rounded-2xl border border-lime-400/25 bg-lime-400/[0.06] p-5 mt-4 flex gap-3">
            <MailCheck className="h-5 w-5 text-lime-400 shrink-0" />
            <p className="text-sm text-white/70">Si un compte existe pour cette adresse, un lien de réinitialisation (valable 1 heure) vient d'être envoyé. Vérifie ta boîte mail.</p>
          </div>
        ) : (
          <>
            <p className="text-white/50 text-sm mb-6">Indique ton email, on t'envoie un lien pour définir un nouveau mot de passe.</p>
            <form onSubmit={submit} className="space-y-3">
              <input data-testid="forgot-email-input" type="email" required placeholder="Ton email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3.5 text-sm outline-none focus:border-lime-400/50" />
              <button data-testid="forgot-submit-button" type="submit" disabled={busy}
                className="w-full inline-flex items-center justify-center gap-2 bg-lime-400 text-black font-extrabold py-3.5 rounded-xl hover:bg-[#b0e600] active:scale-95 transition-all disabled:opacity-60">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Envoyer le lien"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
